import { createAsyncTypes } from 'utils/ActionCreator'

export const AUTO_SYNC_DISABLE_ASYNC = createAsyncTypes(
  'AUTO_SYNC_DISABLE_ASYNC',
  'Mailboxes/Upload'
)
export const GD_ADMIN_EMAIL_CHANGE = 'Mailboxes/Upload/GD_ADMIN_EMAIL_CHANGE'
